<div class="catalog-level-selector" *ngIf="isOpen">
  <div class="catalog-level-selector__header">
    <span class="catalog-level-selector__title">{{ title }}</span>
    <button class="catalog-level-selector__close" type="button" (click)="close()" aria-label="Закрыть">
      <nb-icon icon="close-outline"/>
    </button>
  </div>

  <div class="catalog-level-selector__body">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node">
        <ul class="catalog-level-selector__list">
          <li class="mat-tree-node catalog-level-selector__row">
            <a matTreeNodePadding [matTreeNodePaddingIndent]="10"
               class="catalog-level-selector__label"
               queryParamsHandling="merge"
               (click)="close()"
               [routerLink]="['/catalog']"
               [queryParams]="{catalog_id: node.id, page: null}">
              {{ node.header }}
              <span class="catalog-level-selector__count" *ngIf="node.productCount > 0">{{ node.productCount?.toLocaleString() }}</span>
            </a>

            <ng-container *ngIf="!node.lastLevel">
              <button class="catalog-level-selector__toggle" type="button" matTreeNodeToggle>
                <nb-icon [icon]="treeControl.isExpanded(node) ? 'chevron-up-outline' : 'chevron-down-outline'"
                         [style.color]="treeControl.isExpanded(node) ? 'var(--color-icon-expanded)' : 'var(--color-primary)'"/>
              </button>
              <ul [class.catalog-level-selector__list--hidden]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </ng-container>
          </li>
        </ul>
      </mat-tree-node>
    </mat-tree>
  </div>
</div>
